import {changeSet} from './peachyChangeSet'

export const changeSets = [
    changeSet({id: '001-default-policy-account-type-to-individual-if-not-already-set', author: 'dan.parker'}, async tx => {
        const existingAccountType = await tx.policy.accountType()
        await tx.policy.accountType(existingAccountType ?? 'INDIVIDUAL')
    })
]
